<div>
    <dx-data-grid
        bds-grid
        id="bdsReportGrid"
        [dataSource]="gridSource"
        height="80vh"
        minHeight="200px"
        (onContentReady)="onContentReady($event)"
        [customizeColumns]="customizeColumns"
    >
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxi-column caption="Origin">
            <dxi-column dataField="orig_city" caption="City"></dxi-column>
            <dxi-column dataField="orig_state" caption="State"></dxi-column>
        </dxi-column>
        <dxi-column caption="Car ID">
            <dxi-column dataField="car_init" caption="Init"></dxi-column>
            <dxi-column dataField="car_no" caption="No."></dxi-column>
        </dxi-column>
        <dxi-column
            dataField="ship_date_time"
            caption="Ship Date"
            dataType="datetime"
            format="MM/dd/yy HH:mm"
        ></dxi-column>
        <dxi-column dataField="elapsed_days" caption="Elapsed Days"></dxi-column>
        <dxi-column caption="Location">
            <dxi-column dataField="loc_city" caption="City"></dxi-column>
            <dxi-column dataField="loc_state" caption="State"></dxi-column>
        </dxi-column>
        <dxi-column
            dataField="clm_date_time"
            caption="CLM Date"
            dataType="datetime"
            format="MM/dd/yy HH:mm"
        ></dxi-column>
        <dxi-column dataField="sight_code" caption="Code"></dxi-column>
        <dxi-column dataField="road" caption="Road"></dxi-column>
        <dxi-column dataField="le" caption="L/E"></dxi-column>
        <dxi-column
            dataField="orig_eda_eta_cust"
            caption="ETA to Cust"
            dataType="datetime"
            format="MM/dd/yy HH:mm"
        ></dxi-column>
        <dxi-column caption="Destination">
            <dxi-column dataField="dest_city" caption="City"></dxi-column>
            <dxi-column dataField="dest_state" caption="State"></dxi-column>
        </dxi-column>
        <dxi-column dataField="trip_no" caption="Trip No."></dxi-column>
        <dxi-column dataField="comm_code" caption="Comm Code"></dxi-column>
        <dxi-column dataField="comm_name" caption="Comm Name"></dxi-column>
    </dx-data-grid>
    <div style="text-align: right; padding: 10px; font-weight: bold">
        Total Count: {{ totalCount }}
    </div>
</div>
